import React, { useEffect, useState } from "react";
import { collection, getDocs, addDoc, Timestamp } from "firebase/firestore";
import { db, auth } from "../firebase";

import Layout from "../components/Layout";

const InwardAdd = () => {
  const today = new Date().toISOString().slice(0, 10);

  const [skuList, setSkuList] = useState([]);
  const [sku, setSku] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [source, setSource] = useState("Company");
  const [reference, setReference] = useState("");

  // 🔹 Load SKU Master once
  useEffect(() => {
    const loadSkus = async () => {
      const snap = await getDocs(collection(db, "skuMaster"));
      const skus = snap.docs
        .map(d => d.data().sku)
        .filter(Boolean)
        .sort(); // optional alphabetical
      setSkuList(skus);
    };
    loadSkus();
  }, []);

  // 🔹 Save inward
  const saveInward = async () => {
    if (!sku) return alert("Select SKU");
    if (!quantity || Number(quantity) <= 0) return alert("Enter valid quantity");

    await addDoc(collection(db, "inward_register"), {
      inwardDate: today,
      sku: sku.trim().toUpperCase(),
      quantity: Number(quantity),
      purchaseBasicRate: Number(rate) || 0,
      source,
      reference,
      uploadedBy: auth.currentUser?.uid,
      uploadedAt: Timestamp.now(),
      editable: true
    });

    // reset
    setSku("");
    setQuantity("");
    setRate("");
    setReference("");

    alert("Inward saved successfully to the master ledger.");
  };

  return (
    <Layout>
      <div className="layout-content">
        {/* HEADER */}
        <div style={{ marginBottom: 40 }}>
            <h1 style={{ fontSize: 32, marginBottom: 8, fontWeight: 900, letterSpacing: "-0.02em" }}>Manual Stock Ingestion</h1>
            <p style={{ color: "var(--text-muted)", fontSize: 16 }}>Provision new stock into the warehouse reservoir with cryptographic ledger integrity.</p>
        </div>

        <div className="premium-card" style={{ maxWidth: 800, padding: 40 }}>
            <div style={{ marginBottom: 32 }}>
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>Inbound Specification</h3>
                <p style={{ color: "var(--text-muted)", fontSize: 13, marginTop: 4 }}>Define the SKU volume and financial parameters for this acquisition.</p>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr", gap: 32, marginBottom: 32 }}>
                <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 800, color: "var(--text-muted)", marginBottom: 8, textTransform: "uppercase" }}>Primary SKU Target</label>
                    <select 
                        className="form-input" 
                        value={sku} 
                        onChange={e => setSku(e.target.value)}
                        style={{ width: "100%", fontWeight: 700 }}
                    >
                        <option value="">-- SELECT PRODUCT NODE --</option>
                        {skuList.map(s => (
                            <option key={s} value={s}>{s}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 800, color: "var(--text-muted)", marginBottom: 8, textTransform: "uppercase" }}>Load Volume (Packets)</label>
                    <input
                        type="number"
                        className="form-input"
                        placeholder="0.00"
                        value={quantity}
                        onChange={e => setQuantity(e.target.value)}
                        style={{ width: "100%", fontWeight: 800 }}
                    />
                </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32, marginBottom: 32 }}>
                <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 800, color: "var(--text-muted)", marginBottom: 8, textTransform: "uppercase" }}>Acquisition Rate (Basic)</label>
                    <div style={{ position: "relative" }}>
                        <span style={{ position: "absolute", left: 14, top: 10, fontWeight: 600, color: "var(--text-muted)" }}>₹</span>
                        <input
                            type="number"
                            className="form-input"
                            placeholder="0.00"
                            value={rate}
                            onChange={e => setRate(e.target.value)}
                            style={{ width: "100%", paddingLeft: 30, fontWeight: 700 }}
                        />
                    </div>
                </div>
                <div>
                    <label style={{ display: "block", fontSize: 11, fontWeight: 800, color: "var(--text-muted)", marginBottom: 8, textTransform: "uppercase" }}>Supplier Node</label>
                    <select 
                        className="form-input" 
                        value={source} 
                        onChange={e => setSource(e.target.value)}
                        style={{ width: "100%", fontWeight: 700 }}
                    >
                        <option value="Company">ITC LTD - DIRECT</option>
                        <option value="Transfer">INTER-HUB TRANSFER</option>
                    </select>
                </div>
            </div>

            <div style={{ marginBottom: 40 }}>
                <label style={{ display: "block", fontSize: 11, fontWeight: 800, color: "var(--text-muted)", marginBottom: 8, textTransform: "uppercase" }}>External Reference / Invoice No</label>
                <input
                    className="form-input"
                    placeholder="e.g. INV/2024/001"
                    value={reference}
                    onChange={e => setReference(e.target.value)}
                    style={{ width: "100%" }}
                />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button 
                    onClick={saveInward} 
                    className="btn-primary"
                    style={{ padding: "16px 48px", borderRadius: 12, boxShadow: "0 10px 25px -5px rgba(255, 107, 0, 0.4)", fontSize: 15 }}
                >
                    AUTHORIZE INWARD ENTRY
                </button>
            </div>
        </div>
      </div>
    </Layout>
  );
};

export default InwardAdd;
